import React from "react";
import moment from "moment";

interface PostFooterProps {
  type: string;
  createdAt: string | Date;
  viewCount: number;
  locationName?: string | null;
}

export function PostFooter({ type, createdAt, viewCount, locationName }: PostFooterProps) {
  if (type !== 'detail') return null;

  return (
    <div className="flex items-center gap-1 text-sm text-muted-foreground border-t pt-3 w-full">
      <span>{moment(new Date(createdAt)).format('h:mm A')}</span>
      <span>·</span>
      <span>{moment(new Date(createdAt)).format('MMM D, YYYY')}</span>
      {locationName && (
        <>
          <span>·</span>
          <span>from {locationName}</span>
        </>
      )}
      <span>·</span>
      <span>{viewCount.toLocaleString()} Views</span>
    </div>
  );
}